import { Action } from 'redux';

import {
    APIFailureAction,
    APIRequestAction,
    APISuccessAction,
} from 'mk2/helpers/action';
import { NormalizedResponse } from 'mk2/helpers/api';

// API
export interface ForumTopicsFetchAction extends Action {
    readonly username: string;
    readonly categorySlug: string;
    readonly search: string;
    readonly after: number;
}

export interface ForumTopicsFetchNormalizedResponse  extends NormalizedResponse {
    readonly result: { category: number; followingTopics: number[], topics: number[] };
}

export const FORUM_TOPICS_FETCH_REQUEST = 'FORUM_TOPICS_FETCH_REQUEST';
export interface ForumTopicsFetchRequestAction extends ForumTopicsFetchAction, APIRequestAction {
    readonly type: typeof FORUM_TOPICS_FETCH_REQUEST;
}

export const FORUM_TOPICS_FETCH_SUCCESS = 'FORUM_TOPICS_FETCH_SUCCESS';
export interface ForumTopicsFetchSuccessAction extends ForumTopicsFetchAction, APISuccessAction<ForumTopicsFetchNormalizedResponse> {
    readonly type: typeof FORUM_TOPICS_FETCH_SUCCESS;
    readonly hasNext: number;
    readonly hasPrevious: number;
}

export const FORUM_TOPICS_FETCH_FAILURE = 'FORUM_TOPICS_FETCH_FAILURE';
export interface ForumTopicsFetchFailureAction extends ForumTopicsFetchAction, APIFailureAction {
    readonly type: typeof FORUM_TOPICS_FETCH_FAILURE;
}

export const forumTopicsFetch = {
    request: (username: string, categorySlug: string, search: string, after: number): ForumTopicsFetchRequestAction => ({
        type: FORUM_TOPICS_FETCH_REQUEST,
        username, categorySlug, search, after,
    }),
    success: (username: string, categorySlug: string, search: string, after: number, hasNext: number, hasPrevious: number, response: ForumTopicsFetchNormalizedResponse): ForumTopicsFetchSuccessAction => ({
        type: FORUM_TOPICS_FETCH_SUCCESS, response,
        username, categorySlug, search, after, hasNext, hasPrevious,
    }),
    failure: (username: string, categorySlug: string, search: string, after: number, error: any): ForumTopicsFetchFailureAction => ({
        type: FORUM_TOPICS_FETCH_FAILURE, error,
        username, categorySlug, search, after,
    }),
};

// Triggers
export const FORUM_TOPICS_LOAD = 'FORUM_TOPICS_LOAD';

export interface ForumTopicsLoadAction extends ForumTopicsFetchAction {
    readonly type: typeof FORUM_TOPICS_LOAD;
}

export const forumTopicsLoad = (username: string, categorySlug: string, search: string, after?: number): ForumTopicsLoadAction => ({
    type: FORUM_TOPICS_LOAD,
    username, categorySlug, search, after,
});

export const FORUM_TOPICS_SEARCH = 'FORUM_TOPICS_SEARCH';

export interface ForumTopicsSearchAction extends Action {
    readonly type: typeof FORUM_TOPICS_SEARCH;
    readonly search: string;
    readonly username: string;
    readonly categorySlug: string;
}

export const forumTopicsSearch = (username: string, categorySlug: string, search: string): ForumTopicsSearchAction => ({
    type: FORUM_TOPICS_SEARCH,
    username, categorySlug, search,
});

export const FORUM_TOPICS_UPDATE_SEARCH = 'FORUM_TOPICS_UPDATE_SEARCH';

export interface ForumTopicsUpdateSearchAction extends Action {
    readonly type: typeof FORUM_TOPICS_UPDATE_SEARCH;
    readonly search: string;
}

export const forumTopicsUpdateSearch = (search: string): ForumTopicsUpdateSearchAction => ({
    type: FORUM_TOPICS_UPDATE_SEARCH,
    search,
});
